import { useLang, ui, tx } from "../i18n";

export function MissionStrip() {
  const { lang } = useLang();
  return (
    <section data-testid="mission-strip" className="border-b border-slate-300 bg-white">
      <div className="mx-auto grid max-w-6xl items-start gap-6 px-4 py-10 sm:px-8 sm:py-12 lg:grid-cols-[120px_1fr] lg:px-12">
        <img
          src="/logo.png"
          alt="preparatepr.org — Puerto Rico"
          className="deco hidden w-24 lg:block lg:w-[120px]"
          loading="lazy"
        />
        <div>
          <p className="mb-3 font-mono-pr text-xs font-bold uppercase tracking-[0.2em] text-amber-700">
            {tx(ui.about.missionTitle, lang)}
          </p>
          <p className="max-w-3xl text-base leading-relaxed text-slate-700 sm:text-lg">
            {tx(ui.about.mission, lang)}
          </p>
          <p className="mt-3 max-w-3xl text-base leading-relaxed text-slate-600">
            {tx(ui.about.missionP2, lang)}
          </p>
        </div>
      </div>
    </section>
  );
}
